import { render } from "./CourseSvg.vue?vue&type=template&id=1cb051b0"
const script = {}
script.render = render

export default script